// extracted by mini-css-extract-plugin
export var showSubscribedDistance = "RegisterForm-module__showSubscribedDistance___z3c4q";
export var center = "RegisterForm-module__center___P26Vu";
export var signup = "RegisterForm-module__signup___mSGud";